import { i18n } from '@lingui/core';

import { messages as deMessages } from './locales/de/messages';
import { messages as enMessages } from './locales/en/messages';
import { messages as frMessages } from './locales/fr/messages';
import { messages as itMessages } from './locales/it/messages';

export type Locale = 'de' | 'en' | 'fr' | 'it';

export const SUPPORTED_LOCALES: { value: Locale; label: string }[] = [
  { value: 'de', label: 'Deutsch' },
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
  { value: 'it', label: 'Italiano' },
];

const allMessages: Record<Locale, Record<string, string>> = {
  de: deMessages as Record<string, string>,
  en: enMessages as Record<string, string>,
  fr: frMessages as Record<string, string>,
  it: itMessages as Record<string, string>,
};

/**
 * Activates a locale by loading its message catalog into the i18n instance.
 */
export function activateLocale(locale: Locale): void {
  i18n.load(locale, allMessages[locale]);
  i18n.activate(locale);
}

/**
 * Returns the stored locale or falls back to browser language or 'de'.
 */
export function getDefaultLocale(): Locale {
  const stored = localStorage.getItem('cms-locale') as Locale | null;
  if (stored && allMessages[stored]) return stored;

  const browserLang = navigator.language.split('-')[0] as Locale;
  if (allMessages[browserLang]) return browserLang;

  return 'de';
}

const defaultLocale = getDefaultLocale();
activateLocale(defaultLocale);

export { i18n };
